const LOGIN_TYPE = {
  NONE: '0',
  EMAIL: '010401',
  FACEBOOK: '010402',
  KAKAO: '010403',
  NAVER: '010404',
  CLIENT: '010405',
};

export default LOGIN_TYPE;



// WEBPACK FOOTER //
// ./src/constants/loginType.js